// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const PolygonType = {
  Base: {
    Name: 'Base',
    Value: 'base',
  },
  Location: {
    Name: 'Location',
    Value: 'location',
  },
  Excluded: {
    Name: 'Excluded',
    Value: 'excluded',
  },
} as const

export type PolygonTypeValue = (typeof PolygonType)[keyof typeof PolygonType]['Value']
